import { useState } from 'react';
import axios from 'axios';
import { API_URL } from '../../config';
import type { Custo } from './types';
import { getToken, inputStyle, labelStyle } from './utils';

// Modal pra cadastrar custo unitário inline (chamado do DescricaoComboBox)
export default function ModalCadastrarCusto({ descricaoInicial, onClose, onCriado }: {
  descricaoInicial?: string;
  onClose: () => void;
  onCriado: (novo: Custo) => void;
}) {
  const [descricao, setDescricao] = useState(descricaoInicial || '');
  const [unidade, setUnidade] = useState('un');
  const [valorUnitario, setValorUnitario] = useState('');
  const [categoria, setCategoria] = useState('');
  const [tag, setTag] = useState('');
  const [codigo, setCodigo] = useState('');
  const [salvando, setSalvando] = useState(false);

  async function salvar() {
    if (!descricao.trim()) { alert('Descrição obrigatória'); return; }
    const valor = parseFloat(String(valorUnitario).replace(',', '.'));
    if (isNaN(valor) || valor < 0) { alert('Valor unitário inválido'); return; }
    setSalvando(true);
    try {
      const token = await getToken();
      const res = await axios.post(`${API_URL}/comercial/custos`, {
        descricao: descricao.trim(),
        unidade: unidade.trim() || 'un',
        valor_unitario: valor,
        categoria: categoria.trim() || null,
        tag: tag.trim() || null,
        codigo: codigo.trim() || null,
      }, { headers: { Authorization: token } });
      const data = res.data.body ? JSON.parse(res.data.body) : res.data;
      onCriado(data);
    } catch (e: any) {
      alert('Erro: ' + (e.response?.data?.error || e.message));
    } finally { setSalvando(false); }
  }

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 3500,
    }} onClick={onClose}>
      <div onClick={e => e.stopPropagation()}
        style={{ background: '#fff', borderRadius: 10, padding: 22, width: '94%', maxWidth: 540 }}>
        <h3 style={{ margin: '0 0 16px', fontSize: 14, color: '#020D7F' }}>+ Cadastrar custo unitário</h3>

        <label style={labelStyle}>Descrição *</label>
        <input value={descricao} onChange={e => setDescricao(e.target.value)} autoFocus
          placeholder="Ex.: Engenheiro Júnior — Diária"
          style={inputStyle} />

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginTop: 10 }}>
          <div>
            <label style={labelStyle}>Unidade *</label>
            <input value={unidade} onChange={e => setUnidade(e.target.value)}
              placeholder="Diária, h, km, m, m², L, vb..."
              style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>Valor unitário (R$) *</label>
            <input type="number" step="0.01" min="0"
              value={valorUnitario} onChange={e => setValorUnitario(e.target.value)}
              placeholder="0.00" style={inputStyle} />
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10, marginTop: 10 }}>
          <div>
            <label style={labelStyle}>Categoria</label>
            <input value={categoria} onChange={e => setCategoria(e.target.value)}
              placeholder="Pessoal, Equip., Desloc..."
              list="categorias-sugeridas"
              style={inputStyle} />
            <datalist id="categorias-sugeridas">
              <option value="Pessoal" />
              <option value="Equipamento" />
              <option value="Deslocamento" />
              <option value="Hospedagem" />
              <option value="Taxas" />
              <option value="Materiais" />
            </datalist>
          </div>
          <div>
            <label style={labelStyle}>Tag</label>
            <input value={tag} onChange={e => setTag(e.target.value)}
              placeholder="curto, ex.: TOP-RTK"
              style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>Código</label>
            <input value={codigo} onChange={e => setCodigo(e.target.value)}
              placeholder="opcional"
              style={inputStyle} />
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 16 }}>
          <button onClick={onClose}
            style={{ padding: '8px 16px', fontSize: 12, border: '0.5px solid #ddd',
              borderRadius: 5, background: '#fff', cursor: 'pointer' }}>Cancelar</button>
          <button onClick={salvar} disabled={salvando}
            style={{ padding: '8px 18px', fontSize: 12, fontWeight: 600, border: 'none',
              borderRadius: 5, background: '#0930D0', color: '#fff',
              cursor: salvando ? 'not-allowed' : 'pointer', opacity: salvando ? 0.5 : 1 }}>
            {salvando ? 'Salvando…' : 'Cadastrar e vincular'}
          </button>
        </div>
      </div>
    </div>
  );
}
